/**
 * Created by tomers on 5/19/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var PermissionGroupModel = require("user-management-models/PermissionGroupModel");
    var BaseCollection = require("collections/BaseCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var NAME = "PermissionGroupsCollection";

    var PermissionGroupsCollection = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        PermissionGroupsCollection = BaseCollection.extend({
            ROLES: PermissionGroupModel.ROLES,
            name: NAME,
            model: PermissionGroupModel,
            resource: ApiResources.AppServer.PermissionGroups,

            initialize: function(models, options) {
                options = options ||{};
                options.change404To200OK = false;
                BaseCollection.prototype.initialize.call(this, models, options);
            },

            fetchSuccess: function(collection, response, options) {
                if (options && options.xhr && options.xhr.status !== 304) {
                    this._buildProfilesRolesMap();
                }
            },

            _buildProfilesRolesMap: function() {
                this.profilesRolesMap = {};
                this.each(_.bind(function(profileModel) {
                    var profileRoleType = profileModel.get("name");
                    this.profilesRolesMap[profileRoleType] = this.profilesRolesMap[profileRoleType] || [];
                    this.profilesRolesMap[profileRoleType].push(profileModel.id);
                }, this));
            },

            getProfilesByRole: function() {
                return this.profilesRolesMap;
            }


        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    PermissionGroupsCollection.NAME = NAME;

    return PermissionGroupsCollection;
});
